import React from 'react';
import { heroStats } from '../../data/content';
export function Stats() {
  return <section aria-label="Il sistema in numeri" className="w-full border-y border-navy-deep/10 bg-white px-4 py-8 sm:px-6 sm:py-12" data-id="element-324" data-mp="2fggesn9g1knc">
      <ul className="mx-auto grid max-w-4xl grid-cols-2 gap-x-4 gap-y-7 text-center sm:grid-cols-5 sm:gap-x-2" data-id="element-325" data-mp="2ahmzcpaljjkj">
        {heroStats.map(stat => <li key={stat.label} className="flex flex-col items-center last:col-span-2 sm:last:col-span-1" data-id="element-326" data-mp="335iv9rscd7g9">
            <span className="font-display text-[30px] font-extrabold leading-none text-navy-deep sm:text-4xl" data-id="element-327" data-mp="2y77lti5ykyyk">
              {stat.value}
            </span>
            <span className="mt-2 text-[10.5px] font-bold uppercase tracking-[0.12em] text-navy/60 sm:text-[11px]" data-id="element-328" data-mp="2p69otjtxtrph">
              {stat.label}
            </span>
          </li>)}
      </ul>
    </section>;
}